module.exports = __webpack_public_path__ + "assets/44952b60afbfc08be58d7f6f636ba77c.svg";